/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useAppContext } from '../../context/appContext'
export default function Body2(props) {
  const { colorArr } = useAppContext()
  const { nodes, materials } = useGLTF('/models/Body2.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Body2.geometry}
        material={nodes.Body2.material}
        position={[0, 114.78, 0]}
      >
        <meshPhysicalMaterial
          color={colorArr[3]}
          reflectivity={1}
          roughness={0.8}
        />
      </mesh>
    </group>
  )
}

useGLTF.preload('/models/Body2.glb')
